'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

var MusicalNote = function MusicalNote(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 26 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 26 : _ref$width;
  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-musical-note ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M23,2.30354989 L23,18.3452166 C23,20.3647478 19.9778646,21.0952166 18.4166667,21.0952166 C16.8554688,21.0952166 13.8333333,20.3647478 13.8333333,18.3452166 C13.8333333,16.3256853 16.8554688,15.5952166 18.4166667,15.5952166 C19.3619792,15.5952166 20.3072917,15.7670916 21.1666667,16.1538103 L21.1666667,8.46240405 L10.1666667,11.8569353 L10.1666667,22.0118832 C10.1666667,24.0314145 7.14453125,24.7618832 5.58333333,24.7618832 C4.02213542,24.7618832 1,24.0314145 1,22.0118832 C1,19.992352 4.02213542,19.2618832 5.58333333,19.2618832 C6.52864583,19.2618832 7.47395833,19.4337582 8.33333333,19.820477 L8.33333333,5.97021655 C8.33333333,5.36865405 8.734375,4.83870614 9.30729167,4.65250822 L21.2239583,0.985841552 C21.3528646,0.942872802 21.4817708,0.928549886 21.625,0.928549886 C22.3841146,0.928549886 23,1.5444353 23,2.30354989 Z' })
  );
};

MusicalNote.propTypes = _bcPropTypes.iconShape;

exports.default = MusicalNote;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/MusicalNote/MusicalNote.js
// module id = 1237
// module chunks = 1